module.exports = __webpack_public_path__ + "img/camera-03.134e4b9b.svg";